import React from "react";

import Skeleton from "@mui/material/Skeleton";

import {
  Container,
  Box,
  BoxData,
  Icon,
  Divider,
  DividerCustom,
  Graphs,
  Graphbox,
  GraphPiebox,
  PieChartBox,
  BarChartBox,
  GraphHeader,
  OnGoing,
  Processes,
  ProcessesLabel,
  SmallIcon,
  ProcessData,
  HeaderBox,
} from "./styles";

export const DashboardSkeleton: React.FC = () => {
  return (
    <Container>
      {/* Header Cards Skeleton */}
      <HeaderBox>
        <Box>
          <Box>
            <Icon>
              <Skeleton variant="circular" height={35} width={35} />
            </Icon>
            <BoxData>
              <Skeleton
                height={20}
                width={60}
                style={{ marginBottom: "8px" }}
              />
              <Skeleton height={20} width={40} />
            </BoxData>
          </Box>
          <Divider />
          <Box>
            <Icon>
              <Skeleton variant="circular" height={35} width={35} />
            </Icon>
            <BoxData>
              <Skeleton
                height={20}
                width={60}
                style={{ marginBottom: "8px" }}
              />
              <Skeleton height={20} width={40} />
            </BoxData>
          </Box>
        </Box>
        <DividerCustom />
        <Box>
          <Box>
            <Icon>
              <Skeleton variant="circular" height={35} width={35} />
            </Icon>
            <BoxData>
              <Skeleton
                height={20}
                width={70}
                style={{ marginBottom: "8px" }}
              />
              <Skeleton height={20} width={40} />
            </BoxData>
          </Box>
          <Divider />
          <Box>
            <Icon>
              <Skeleton variant="circular" height={35} width={35} />
            </Icon>
            <BoxData>
              <Skeleton
                height={20}
                width={120}
                style={{ marginBottom: "8px" }}
              />
              <Skeleton height={20} width={40} />
            </BoxData>
          </Box>
        </Box>
      </HeaderBox>

      {/* Charts Section Skeleton */}
      <Graphs>
        <Graphbox>
          <GraphHeader>
            <Skeleton
              height={24}
              width={200}
              style={{ marginBottom: "10px" }}
            />
          </GraphHeader>
          <BarChartBox>
            <Skeleton height={300} style={{ margin: "20px" }} />
          </BarChartBox>
        </Graphbox>

        <GraphPiebox>
          <PieChartBox>
            <GraphHeader>
              <Skeleton
                height={20}
                width={280}
                style={{ marginBottom: "10px" }}
              />
            </GraphHeader>
            <div style={{ padding: "20px" }}>
              <Skeleton
                variant="circular"
                height={200}
                width={200}
                style={{ margin: "0 auto" }}
              />
            </div>
          </PieChartBox>
          <PieChartBox>
            <GraphHeader>
              <Skeleton
                height={20}
                width={240}
                style={{ marginBottom: "10px" }}
              />
            </GraphHeader>
            <div style={{ padding: "20px" }}>
              <Skeleton
                variant="circular"
                height={200}
                width={200}
                style={{ margin: "0 auto" }}
              />
            </div>
          </PieChartBox>
        </GraphPiebox>
      </Graphs>

      {/* Legend Skeleton */}
      <div style={{ margin: "20px 0" }}>
        <Skeleton height={16} width="80%" style={{ marginBottom: "8px" }} />
        <Skeleton height={16} width="75%" />
      </div>

      {/* Ongoing Processes Skeleton */}
      <OnGoing>
        <GraphHeader>
          <Skeleton height={24} width={180} style={{ marginBottom: "20px" }} />
        </GraphHeader>

        {[1, 2, 3].map((index) => (
          <Processes key={index}>
            <ProcessesLabel>
              <SmallIcon>
                <Skeleton variant="circular" height={25} width={25} />
              </SmallIcon>
              <Skeleton height={18} width={150} />
            </ProcessesLabel>
            <ProcessData>
              <Skeleton
                height={20}
                width={30}
                style={{ marginRight: "10px" }}
              />
              <Skeleton variant="circular" height={40} width={40} />
            </ProcessData>
          </Processes>
        ))}
      </OnGoing>
    </Container>
  );
};
